import {
  ACTION_GET_BASIC_ECONOMY_FEATURE,
  ACTION_GET_BASIC_ECONOMY_FEATURE_SUCCESS,
  ACTION_GET_BASIC_ECONOMY_FEATURE_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function getBasicEconomyFeature(organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/features/basic-economy`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_BASIC_ECONOMY_FEATURE_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_BASIC_ECONOMY_FEATURE_FAILURE,
    payload: responseJSON,
  };
}
